module.exports = __webpack_public_path__ + "static/img/eyes_07.f359fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_07.png
// module id = fnqx
// module chunks = 0